export const HELP_TEXT = [
  {
    id: "__aiButton",
    helpText:
      "Invokes the AI chat, allowing the user to ask questions in regard to the data on the current view.",
  },
  {
    id: "__collabToolbarSettings",
    helpText: "Opens the Settings for the CollabCenter",
  },
  {
    id: "__dashboardProjectTeam",
    helpText:
      "List of team members.  A person must be a team member in order to be assigned to RAID log items or Requirements or to receive emails from the Message board.",
  },
  { id: "__dashboardProjectTeamAdd", helpText: "Project Team Add" },
  { id: "__dashboardProjectTeamMenu", helpText: "Project Team Menu" },
  {
    id: "__dashboardProjectLinks",
    helpText: "List of website links that are used with this project",
  },
  { id: "__dashboardProjectLinksAdd", helpText: "Click to add a new link" },
  {
    id: "__dashboardProjectLinksMenu",
    helpText: "Click to edit or remove a link",
  },
  {
    id: "__dashboardProjectDocuments",
    helpText:
      "Add documents or other files as references for this project.  These are stored in the project's workspace in SuiteProjects Pro or in the Addolution Storage system (AS).",
  },
  { id: "__dashboardProjectDocumentsAdd", helpText: "Click to add a new file" },
  {
    id: "__dashboardProjectDocumentsMenu",
    helpText: "Click to remove a file from the list",
  },
  {
    id: "__dashboardProjectHealthSPI",
    helpText:
      "The Schedule Performance Index compares how much you planned to spend for the work you ACTUALLY did against how much you planned to spend for the work you PLANNED to do.  A value less than 1 indicates the project is behind schedule, while a value greater than one suggests the project is ahead.",
  },
  {
    id: "__dashboardProjectHealthCPI-H",
    helpText:
      "The Cost Performance Index compares how much you PLANNED to spend for the work you actually did against how much you ACTUALLY spent for the work you actually did.  A value less than 1 indicates the project is over the expected budget, while a value greater than one suggests the project is under budget.",
  },
  {
    id: "__dashboardTasks",
    helpText:
      "Tasks that are overdue (in red), tasks expected to currently be in progress, and tasks expected to start soon (as determined in the application settings).  The list shows the start and end dates and the stored percent complete.",
  },
  {
    id: "__dashboardProjectMetrics_grid",
    helpText:
      "Actual worked hours logged in SuiteProjects Pro for this project, encompassing all approval and billable statuses",
  },
  {
    id: "__dashboardProjectMetricsActualHours",
    helpText:
      "Actual worked hours logged in SuiteProjects Pro for this project, encompassing all approval and billable statuses",
  },
  {
    id: "__dashboardProjectMetricsActualMoney",
    helpText:
      "Amounts from charges in SuiteProjects Pro for this project, whether invoiced yet or not",
  },
  {
    id: "__dashboardProjectMetricsBar",
    helpText:
      "Budget, Actual amounts, and Estimate to Complete.  Clicking the graph switches between Hours and Money.",
  },
  {
    id: "__dashboardProjectMetricsETCHours",
    helpText:
      "Estimated hours needed to complete the project, calculated as the sum of future bookings",
  },
  {
    id: "__dashboardProjectMetricsETCMoney",
    helpText:
      "Estimated cost to complete the project, calculated as the sum of future charge projections",
  },
  {
    id: "__dashboardProjectMetricsEACHours",
    helpText:
      "Expected hours for the proejct in total, calculated as the actual hours plus the estimated hours to complete",
  },
  {
    id: "__dashboardProjectMetricsEACMoney",
    helpText:
      "Expected cost for the project in total, calculated as the acutal cost plus the estimated cost to complete",
  },
  {
    id: "__dashboardProjectMetricsBudgetHours",
    helpText: "Budgeted hours for the project in total",
  },
  {
    id: "__dashboardProjectMetricsBudgetMoney",
    helpText: "Budgeted cost to the customer of the project in total",
  },
  {
    id: "__dashboardProjectMetricsDiffHours",
    helpText:
      "Budgeted hours for the project minus the hours expected at completion.  A positive number indicates a budget surplus of that amount, while a negative number shows a budget shortfall.",
  },
  {
    id: "__dashboardProjectMetricsDiffMoney",
    helpText:
      "Budgeted cost to the customer for the project minus the cost expected at completion.  A positive number indicates a budget surplus of that amount, while a negative number shows a budget shortfall.",
  },
  {
    id: "__dashboardProjectMetricsPctComplete",
    helpText:
      "The percent complete for the project as stored in SuiteProjects Pro",
  },
  {
    id: "__discussionMain",
    helpText:
      "This is a continuous discussion page within the team for this project. All new entries will be emailed to the subscribers.",
  },
  {
    id: "__discussionSubscribe",
    helpText:
      "Indicates whether you are subscribed (white envelope) or unsubscribed (red envelope) from the emails from this thread.  Click the icon to change subscription status.",
  },
  {
    id: "__discussionSubscribers",
    helpText:
      "Displays the e-mail addresses of all the subscribers of this discussion",
  },
  {
    id: "__discussionRefresh",
    helpText:
      "The discussion page is not live; clicking this button will refresh the discussion",
  },
  {
    id: "__discussionClearFilter",
    helpText: "Click this icon to clear the current filter",
  },
  {
    id: "__discussionHashtags",
    helpText:
      "Adding a topic with a preceding hashtag (#) will create a button in this list.  Clicking the button will filter the messages to show only messages with that hashtag.",
  },
  {
    id: "__discussionSearch",
    helpText: "Search for any text within the discussion",
  },
  {
    id: "__discussionMessageBox",
    helpText:
      "Enter new messages for the discussion here.  Click the Submit button to post the message.",
  },
  {
    id: "__discussionSubmit",
    helpText: "Click this button to post the new message to the discussion",
  },
  {
    id: "__issuesAddIssue",
    helpText: "Click this button to register a new issue for this project",
  },
  {
    id: "__issuesName",
    helpText: "Prefix and numeric ID of the issue",
  },
  {
    id: "__issuesDate",
    helpText: "Date the issue was registered",
  },
  {
    id: "__issuesSynopsis",
    helpText: "Brief description of the issue",
  },
  {
    id: "__issuesStage",
    helpText:
      "Stage of the issue, typically used to identify closure and ownership status",
  },
  {
    id: "__issuesUser",
    helpText: "The resource who currently has ownership of the issue",
  },
  {
    id: "__issuesExpected",
    helpText:
      "The date when the owner of the issue expects it will be resolved",
  },
  {
    id: "__issuesRequired",
    helpText:
      "The date the person entering hte issue requires it to be resolved",
  },
  {
    id: "__issuesResolved",
    helpText: "The date the issue was resolved",
  },
  {
    id: "__reqSynopsis",
    helpText: "Brief description of the requirement",
  },
  {
    id: "__reqStage",
    helpText:
      "Stage of the requirement, generally related to its approval status",
  },
  {
    id: "__reqCategory",
    helpText:
      "Category of the requirement.  These can be configured in the Requirment Settings screen.",
  },
  {
    id: "__reqApprovals",
    helpText: "Project team members assigned to appprove the requirement",
  },
  {
    id: "__reqUnassigned",
    helpText:
      "Project team members who do not have approval or acknowledgement responsibility for the requirement",
  },
  {
    id: "__reqAcknowledgements",
    helpText:
      "Project team membees expected for formally acknowledge they have read and understsand the requirement",
  },
];
